<div class="login-page black-bg">
  <div class="container d-flex ">
    <div class="form-holder has-shadow ">
      <div class="row justify-content-md-center">
        <!-- Form Panel    -->
        <div class="col-lg-5">
          <div class="form d-flex login-form">
            <div class="content" *ngIf="!newSite">
              <br />
              <img src="assets/images/logo-white.png" width="100%" /><br /><br />
              <div style="padding: 40px">
                <form (ngSubmit)="login()" [formGroup]="loginForm" class="form-validate" novalidate *ngIf="loginForm">
                  <div class="form-group">
                    <input
                      type="text"
                      formControlName="email"
                      autocomplete="off"
                      id="login-username"
                      class="input-material"
                      placeholder="Email"
                      [disableControl]="!(loading$ | async)"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      formControlName="password"
                      required
                      id="login-password"
                      class="input-material"
                      placeholder="Password"
                      [disableControl]="!(loading$ | async)"
                    />
                  </div>
                  <br />
                  <button
                    class="btn btn-primary"
                    type="submit"
                    [disabled]="loginForm.invalid || (loading$ | async)"
                    id="login"
                  >
                    <ng-container *ngIf="!(loading$ | async)">
                      <span translate>Login</span>
                    </ng-container>
                    <ng-container *ngIf="loading$ | async">
                      <span translate>Loading..</span>
                    </ng-container>
                  </button>
                  <!-- This should be submit button but I replaced it with <a> for demo purposes-->
                </form>
                <a [routerLink]="['/forgot']" class="forgot-pass white">Forgot Password?</a><br /><small
                  class="white fLite"
                  >Do not have an account? </small
                ><a class="signup create-account-btn" [routerLink]="['/register']">Create Free Account</a>
              </div>
            </div>
            <div class="content" *ngIf="newSite">
              <div style="display: flex; justify-content:space-between;align-items: baseline; padding: 10px">
                <img src="assets/images/logo-white.png" width="200px" />
                <button
                  (click)="newSite = false"
                  class="btn btn-primary"
                  type="type"
                  id="login"
                  style="margin: auto 15px;"
                >
                  Log in
                </button>
              </div>
              <div align="center">
                <img src="assets/images/1.jpg" width="100%" />
                <img src="assets/images/2.jpg" width="100%" />
                <img src="assets/images/3.jpg" width="100%" />
                <!-- <a
                  href="https://heypogi.uscreen.io/"
                  style="background: white;
                color: #031049;
                border-radius: 8px;
                padding: 20px 30px;
                font-size: 20px;"
                  >New Website</a
                >
                <span style="padding: 20px 40px"
                  >Best for New Subscribers and Previous Subscribers with no Active Premium Access</span
                >
                <br />
                <br />
                <button
                  type="button"
                  (click)="newSite = false"
                  style="background: #c5c5c5;
                color: #031049;
                border-radius: 8px;
                padding: 20px 30px;
                font-size: 20px;"
                >
                  Old Website
                </button>
                <span style="padding: 20px 40px">Best for Previous Subscribers with Active Premium Access</span> -->
                <br />
                <br />

                <h4
                  style="    font-size: 16px;
                color: white;
                margin-bottom: 15px;"
                >
                  Stories of Men who Love Men
                </h4>
                <button (click)="newSite = false" class="btn btn-primary" type="type" id="login">
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
